import {Category} from "./category.model";

export const categoryMock: Array<Category> = [{
  identifier: "gc20",
  label: "Agriculture"
}];
